import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarPresenceOfflineExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" presence="offline" />;
};

export default AvatarPresenceOfflineExample;
